module.exports = __webpack_public_path__ + "images/category_lp/pc/navigater_a337f9358adfbb5ddc47b3ca05920255.png";